import loadable from "@loadable/component";

// Export named exports from specific components
export * from "./Button";

// Loadable versions of components with dynamic imports
export const Breadcrumb = loadable(() => import("./Breadcrumb/index"));
export const AuthLogo = loadable(() => import("./AuthLogo/index"));
export const TabComponent = loadable(() => import("./Tabs/index"));
export const GlobalLoader = loadable(() => import("./GlobalLoader/index"));
export const FileUploader = loadable(() => import("./FileUploader/index"));
export const Charts = loadable(() => import("./Chart/index"));
export const ModalComponent = loadable(() => import("./Modal/Index"));
export const DataTable = loadable(() => import("./DataTable/index"));
export const Pagination = loadable(() => import("./Pagination/index"));
export const ActionDropdown = loadable(() => import("./ActionDropdown/index"));
export const SweetAlert = loadable(() => import("./SweetAlert/index"));
export const ImageElement = loadable(() => import("./ImageElement/index"));
export const RippleEffect = loadable(() => import("./RippleEffect/index"));

// Loadable versions for header components
export const UserHeader = loadable(() => import("./Header/index"));
export const AcountSidebar = loadable(() => import("./AcountSidebar/index"));
export const AccordionComponent = loadable(() =>
  import("./AccordionComponent/index"),
);
export const LinkComponent = loadable(() => import("./LinkComponent/index"));
export const NoDataFound = loadable(() => import("./NoDataFound/index"));
export const TextEditor = loadable(() => import("./TextEditor/index"));
